import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const affiliateUrl = (item) =>
  `https://www.amazon.it/s?k=${encodeURIComponent(item.replace(/-/g, " "))}`;

export const trackAffiliate = async (item, url) => {
  try {
    await api.get("/affiliate/track", { params: { item, url } });
  } catch (e) {
    /* non-blocking */
  }
  window.open(url, "_blank", "noopener");
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
